import { render, staticRenderFns } from "./ClientWeekDots.vue?vue&type=template&id=dc3f8c5c&scoped=true&"
import script from "./ClientWeekDots.vue?vue&type=script&lang=js&"
export * from "./ClientWeekDots.vue?vue&type=script&lang=js&"
import style0 from "./ClientWeekDots.vue?vue&type=style&index=0&id=dc3f8c5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc3f8c5c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VAvatar,VBtn,VCol,VIcon,VRow,VSkeletonLoader,VSpacer,VTab,VTabs})
